import React from "react";
import {
    Button,
    convertInputFormToObject,
    SelectField
} from "../../../../Components/Inputs";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {LinkButton} from "../../../../Components/Link";
import {locations} from "../../../../Utilities/Location";
import {isObjectNullOrEmpty} from "../../../../Utilities/Types/objectUtilities";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface LoanLibraryQueueFormProps {
    queueForm: Record<string, any>;
    shippingLocations: ListItem[];
    handleAssignQueueItems: (data: Record<string, unknown>) => void;
    setWarnings: (warnings: string[]) => void;
}

export const LoanLibraryQueueForm = ({
                                         queueForm,
                                         shippingLocations,
                                         handleAssignQueueItems,
                                         setWarnings,
                                     }: LoanLibraryQueueFormProps) => {

    const handleClickSubmit = () => {
        if (!queueForm) {
            setWarnings(["Form is not properly initialized. Please refresh the page."]);
            return;
        }
        
        const loanModel = convertInputFormToObject(queueForm);
        
        if (!loanModel.shippingLocationId || loanModel.shippingLocationId === '') {
            setWarnings(["Missing required items.  Please review your responses and try submitting again."]);
            return;
        }

        handleAssignQueueItems(loanModel);
    };

    if (!queueForm) {
        return null;
    }

    if (isObjectNullOrEmpty(shippingLocations)) {
        return null;
    }

    return <>
        <GridContainer hasMarginX>
            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}
                      medium_offset={gridConstants.column.SIX} large_offset={gridConstants.column.SIX}>
                <SelectField
                    {...queueForm.shippingLocationId}
                    defaultOption={`Select Shipping Location`}
                    label={`Location`}
                    helpText={`<p><b>Please ship to your school address if possible to reduce shipping costs.</b></p>`}
                    options={shippingLocations}
                />
            </GridCell>
            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}
                      medium_offset={gridConstants.column.SIX} large_offset={gridConstants.column.SIX}>
                <LinkButton {...locations.SHIPPING_LOCATION_ADD.link} isExpanded/>
            </GridCell>

            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}
                      medium_offset={gridConstants.column.SIX} large_offset={gridConstants.column.SIX}
                      className="text-right">
                <Button
                    isPrimary
                    isCollapsed
                    type="button"
                    label={`Submit`}
                    name={`btnSubmit`}
                    onClick={handleClickSubmit}
                />
            </GridCell>
        </GridContainer>
        <br/>
        <br/>
    </>;
};

